<template>
  <div>
    <b-row>
      <b-col class="col-12 col-lg-6">
        <h4>Cargar nueva licencia</h4>
        <LmForm id="license-form">
          <LmTextInput
            v-if="isAdmin"
            disabled
            label="Usuario"
            :multiple="false"
            v-model="userFullName"
            :clearable="true"
          />
          <label class="mt-2">Fecha de inicio</label>
          <b-form-datepicker id="start-datepicker" v-model="licenseForm.start" class="mb-2" :min="min" placeholder="Seleccione una fecha" locale="es-AR"></b-form-datepicker>
          <label class="mt-2">Fecha de fin</label>
          <b-form-datepicker id="finish-datepicker" v-model="licenseForm.finish" class="mb-3" :min="licenseForm.start || min" placeholder="Seleccione una fecha" locale="es-AR"></b-form-datepicker>
          <LmTreeSelect
            class="mt-2"
            label="Reemplazante"
            clearable
            :pathToGetOptions="pathToGetUsers"
            v-model="licenseForm.substitute"
          />
          <!-- <LmTreeSelect
            label="Cargo"
            class="col-12 px-0"
            pathToGetOptions="/customer/position"
            :multiple="false"
            v-model="licenseForm.provisionalPosition"
            :clearable="true"
          /> -->
          <LmTextInput
            id="licenseform-provisionalposition"
            placeholder="Cargo provisorio"
            v-model="licenseForm.provisionalPosition"
            label="Cargo"
          />
        </LmForm>
      </b-col>
      <b-col class="col-12 col-lg-6">
        <h4>{{licensesTitle}}</h4>
        <b-tabs content-class="mt-3">
          <!-- Licencias Activas -->
          <b-tab title="Activas" active>
            <b-card
              class="border"
              v-for="license in activeLicenses"
              :key="license._id"
            >
              <b-card-title class="text-center my-0 py-2 border-bottom">{{`${license.start} - ${license.finish}`}}</b-card-title>
              <b-card-text class="mt-2"><strong>Estado:</strong> {{license.canBeFinished ? 'Activa' : 'Programada'}}</b-card-text>
              <b-card-text class="mt-2"><strong>Reemplazante:</strong> {{license.substitute ? license.substitute.name : '-'}}</b-card-text>
              <b-card-text><strong>Cargo provisorio:</strong> {{license.provisionalPosition ? license.provisionalPosition : '-'}}</b-card-text>
              <b-button v-if="license.canBeFinished" variant="primary" class="mr-3" @click="finishLicense(license._id)">Finalizar</b-button>
              <b-button v-if="!license.canBeFinished" variant="danger" @click="deleteLicense(license._id)">Eliminar</b-button>
            </b-card>
            <LmSvgIcon
              v-if="!activeLicenses.length"
              wrapperClass="d-flex h-100 justify-content-center align-items-center flex-column mt-5"
              width="6em"
              icon="LmNoDataIcon"
              text="No hay licencias cargadas"
            />
          </b-tab>
          <!-- Licencias Finalizadas -->
          <b-tab title="Finalizadas">
            <b-card
              class="border"
              v-for="license in finishedLicenses"
              :key="license._id"
            >
              <b-card-title class="text-center my-0 py-2 border-bottom">{{`${license.start} - ${license.finish}`}}</b-card-title>
              <b-card-text class="mt-2"><strong>Reemplazante:</strong> {{license.substitute ? license.substitute.name : '-'}}</b-card-text>
              <b-card-text><strong>Cargo provisorio:</strong> {{license.provisionalPosition ? license.provisionalPosition : '-'}}</b-card-text>
              <b-card-text><strong>Finalizada:</strong> {{license.finishedAt ? license.finishedAt : '-'}}</b-card-text>
            </b-card>
            <LmSvgIcon
              v-if="!finishedLicenses.length"
              wrapperClass="d-flex h-100 justify-content-center align-items-center flex-column mt-5"
              width="6em"
              icon="LmNoDataIcon"
              text="No hay licencias finalizadas"
            />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <LmConfirmationModal ref="lmConfirmationModalLicenses" message="Usted va a eliminar/finalizar una licencia. ¿Está seguro?" title="Aviso" />
  </div>
</template>

<script>
import lmToasts from '@/mixins/lmToasts.js'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmForm from '@/components/form/LmForm'
import LmConfirmationModal from '@/components/modals/LmConfirmationModal.vue'
import commonsApi from '@/api/commons'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts],
  data () {
    return {
      activeLicenses: [],
      finishedLicenses: [],
      licenseForm: {
        userId: null,
        start: null,
        finish: null,
        substitute: null
      },
      userFullName: ''
    }
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
    user: {
      type: String,
      default: null
    }
  },
  validations: {
    licenseForm: {
      start: {
        required
      },
      finish: {
        required
      }
    }
  },
  components: {
    LmTreeSelect,
    LmButton,
    LmTextInput,
    LmForm,
    LmConfirmationModal
  },
  computed: {
    min () {
      const today = new Date()
      return today
    },
    licensesTitle () {
      if (this.isAdmin) {
        return 'Licencias'
      } else {
        return 'Mis Licencias'
      }
    },
    pathToGetUsers () {
      if (this.isAdmin) {
        return `/users/allexceptthis/${this.user}`
      } else {
        return '/users/allexceptme'
      }
    }
  },
  methods: {
    async saveNewLicense () {
      console.log('pasa por aquí...')
      // this.$v.licenseForm.$touch()
      // if (!this.$v.licenseForm.$invalid) {
      //   try {
      //     await commonsApi.axiosPostWrapper('/licenses', this.licenseForm)
      //     this.lmToastSuccessMessage(`Se cargó la licencia correctamente.`, 'Licencia cargada')
      //     this.getUserAndLicensesInfo(this.isAdmin)
      //     this.resetLicenseForm()
      //   } catch (error) {
      //     console.log(error)
      //   }
      // }
    },
    resetLicenseForm () {
      this.licenseForm = {}
    },
    async deleteLicense (id) {
      try {
        await this.$refs.lmConfirmationModalLicenses.lmShow()
        const dataToSendToServer = {
          id,
          userId: this.licenseForm.userId
        }
        await commonsApi.axiosPutWrapper('/licenses/delete', dataToSendToServer)
        this.lmToastSuccessMessage('Se eliminó la licencia correctamente.', 'Licencia eliminada')
        this.getUserAndLicensesInfo(this.isAdmin)
      } catch (error) {
        console.log(error)
      }
    },
    async finishLicense (id) {
      try {
        await this.$refs.lmConfirmationModalLicenses.lmShow()
        const dataToSendToServer = {
          id,
          userId: this.licenseForm.userId
        }
        await commonsApi.axiosPutWrapper('/licenses/finish', dataToSendToServer)
        this.lmToastSuccessMessage('Se finalizó la licencia correctamente.', 'Licencia finalizada')
        this.getUserAndLicensesInfo(this.isAdmin)
      } catch (error) {
        console.log(error)
      }
    },
    async getUserAndLicensesInfo (isAdmin) {
      // Obtengo la información del usuario
      let getUser
      if (isAdmin) {
        getUser = await commonsApi.axiosGetWrapper(`/profile/getuserinfo/${this.user}`)
      } else {
        getUser = await commonsApi.axiosGetWrapper(`/profile/userinfo`)
      }
      const user = getUser.data
      this.licenseForm.userId = user.userId
      this.userFullName = `${user.firstname} ${user.lastname}`

      // Obtengo licencias activas del usuario
      const getActiveLicenses = await commonsApi.axiosGetWrapper(`/licenses/actives/${user.userId}`)
      this.activeLicenses = getActiveLicenses.data

      // Obtengo licencias finalizadas del usuario
      const getFinishedLicenses = await commonsApi.axiosGetWrapper(`/licenses/finished/${user.userId}`)
      this.finishedLicenses = getFinishedLicenses.data
    }
  },
  async mounted () {
    this.getUserAndLicensesInfo(this.isAdmin)
  }
}
</script>
